export default __webpack_public_path__ + "media/images/iui/toolbar-d66c74d6c20911ac2ae219dd2ad3a96d.png";